import { CSSProperties, Dispatch, forwardRef, PropsWithChildren, SetStateAction } from 'react'
import ThreeDotsIcon from '@/assets/icons/three-dots-menu.svg?react'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import ClickableIcon from '@/shared/Common/ClickableIcon'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  style?: CSSProperties
  iconStyle?: CSSProperties
  menuStyle?: CSSProperties
  onOpenStateChange?: (open: boolean) => void
  position?: 'right' | 'left'
}

const DropdownUnderThreeDots = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>((props, ref) => {
  return (
    <div ref={ref} style={{ position: 'relative' }} onClick={(ev) => ev.stopPropagation()} data-open={open}>
      <ClickableIcon
        icon={ThreeDotsIcon}
        active={props.open}
        onClick={() => props.setOpen((prev) => !prev)}
        size="default"
      />
      <DropdownFadeInPanel
        position={props.position || 'right'}
        open={props.open}
        style={{ top: '28px', width: '200px', ...(props.style || {}) }}
        onClick={() => props.setOpen(false)}
      >
        {props.children}
      </DropdownFadeInPanel>
    </div>
  )
})

export default DropdownUnderThreeDots
